import { Reducer } from 'redux'
import { fromJS } from 'immutable'
import { ICountries } from './../models'
import * as TYPES from './../actionTypes'

export const initialState: ICountries = fromJS({
  loading: false,
  countries: [],
})

const countriesReducer: Reducer<ICountries> = (state = initialState, action) => {
  switch (action.type) {
    case TYPES.SET:
      return state.merge(action.payload)
    case TYPES.CONTENT.TRIGGER:
      return state.set('loading', true)
    case TYPES.CONTENT.SUCCESS:
      return state.merge(action.payload)
    case TYPES.CONTENT.FAILURE:
      return state.set('error', action.payload)
    case TYPES.CONTENT.FULFILL:
      return state.set('loading', false)
    default:
      return state
  }
}

export default countriesReducer
